import flightIcon from "../../assets/img/icon/plane-right-blue.png";
import { useTranslation } from "react-i18next";
import { parseFlight } from "helpers/flightHelper";
import { formatPrice } from "helpers/common";
import { useFlightContext } from "hooks/flight/useFlightContext";
import useApiClient from "hooks/useApiClient";
import { FaPlane } from "react-icons/fa6";
import { BsEyeFill } from "react-icons/bs";
import useToggle from "hooks/useToggle";
import FlightDetailModal from "./FlightDetailsModal";
import useAirValidate from "hooks/flight/useAirValidate";
import BaggageWarning from "./BaggageWarning";

const FlightCard = ({ flight, index }) => {
    const { t } = useTranslation();
    const { availabilityResults, flightSearchParams } = useFlightContext();
    const { handleBooking } = useAirValidate();
    const { isOpen, toggle } = useToggle();
    const { isOpen: isBaggageWarningOpen, toggle: toggleBaggageWarning } =
        useToggle();
    const { airlineDictionary, airportDictionary } = availabilityResults || {};
    const parsedFlight = parseFlight(
        flight,
        airportDictionary,
        airlineDictionary,
    );

    const baggagePerBound = flight?.baggagePerBound || [];
    const hasNoBaggage = baggagePerBound.some((b) => b?.withBaggage === false);

    const bookingClickHandler = () => {
        if (hasNoBaggage) {
            toggleBaggageWarning();
            return;
        }
        //TODO TRAVEL_FUSION CASE
        handleBooking(flight);
    };
    return (
        <div className="flight_search_item_wrappper" key={index}>
            <div className="flight_search_items">
                <div className={`w-full flex flex-col gap-0 relative`}>
                    {parsedFlight?.bounds.map((bound, index) => (
                        <>
                            {index > 0 && <hr className="my-2" />}
                            <Bound
                                bound={bound}
                                key={index}
                                isOpenReturnBound={flightSearchParams?.openReturn && index === 1}
                            />
                        </>
                    ))}
                    <div className="flex w-full justify-center px-2 py-1 ">
                        {flight?.flightNeedExchangeDocuments && (
                            <p className="text-red-500 text-sm ">
                                {t("flightExchangeDocumentsRequired")}
                            </p>
                        )}
                    </div>
                </div>
                <div
                    className={`flight_search_right flex flex-col gap-2 items-center h-fit ${parsedFlight?.bounds.length > 1 ? "md:h-[300px]" : "md:h-fit"}`}
                >
                    <h2 className="text-2xl font-bold whitespace-nowrap">
                        {formatPrice(parsedFlight?.price)}
                    </h2>
                    <div
                        onClick={() => {
                            bookingClickHandler();
                        }}
                        className={`btn btn_theme btn_sm w-full py-2 cursor-pointer hover:text-white `}
                    >
                        <div className={`font-semibold `}>{t("bookNow")}</div>
                    </div>
                    {/* <p>*Discount applicable on some conditions</p> */}
                    <div
                        onClick={toggle}
                        className="flex flex-row bg-transparent text-[14px] border-none text-secondary-color cursor-pointer mt-3 items-center"
                    >
                        <BsEyeFill className=" me-1" />
                        <span className="">{t("flightDetails")}</span>
                    </div>
                </div>
            </div>
            <FlightDetailModal
                isOpen={isOpen}
                toggle={toggle}
                flight={flight}
            />
            <BaggageWarning
                isOpen={isBaggageWarningOpen}
                toggle={toggleBaggageWarning}
                handleBooking={handleBooking}
                flight={flight}
            />
        </div>
    );
};

export default FlightCard;

const Bound = ({ bound, isOpenReturnBound }) => {
    const { t } = useTranslation();
    const { urls } = useApiClient();
    const airlineImg = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${bound?.airline}.png`;
    return (
        <div className="flex   items-start justify-between  sm:items-center gap-2 w-full p-3 sm:p-0">
            <div className="  flex flex-col  items-center justify-center ">
                {isOpenReturnBound ? (
                    <div className="flex flex-col items-center justify-center text-center px-1">
                        <span className="text-xs font-semibold text-green-700 leading-tight">
                            {t("openReturn")}
                        </span>
                        {bound?.date && (
                            <>
                                <span className="text-xs text-green-600 mt-0.5">
                                    {t("until")}
                                </span>
                                <span className="text-xs text-green-600">
                                    {bound.date}
                                </span>
                            </>
                        )}
                    </div>
                ) : (
                    <>
                        <img
                            src={airlineImg}
                            className=" object-cover size-12"
                            alt="img"
                        />
                        <div className="text-sm font-semibold">
                            {bound?.airline_name}{" "}
                        </div>
                    </>
                )}
            </div>
            <div className="flex flex-col sm:flex-row  items-end sm:items-center flex-1">
                <div className="flex flex-col items-center flex-1">
                    <h3 className="font-semibold">{bound?.departure_time}</h3>
                    <h6 className="text-paragraph-color text-[14px] w-[150px] text-center ">
                        {bound?.departure_airport}
                    </h6>
                </div>
                <div className="flight_right_arrow hidden sm:flex flex-col items-center gap-1 mx-5">
                    <img src={flightIcon} alt="icon" />
                    {!isOpenReturnBound && <h6>{bound?.nbStops}</h6>}
                    {!isOpenReturnBound && <p>{bound?.duration}</p>}
                </div>
                <div className="flex sm:hidden   -translate-x-[20px] gap-3 my-3">
                    <div
                        className="position-relative border-main-color   "
                        style={{
                            width: "0px",
                            borderColor: "var(--main-color)",
                            border: "1px dashed",
                            height: "90px",
                        }}
                    >
                        <div className="icon-md  text-white rounded-circle position-absolute top-50 start-50 translate-middle flex-centered">
                            <FaPlane
                                size={20}
                                className="fa-fw text-main-color"
                                style={{ transform: "rotate(90deg)" }}
                            />
                        </div>
                    </div>
                    {!isOpenReturnBound && (
                        <div className="d-flex flex-column justify-content-center">
                            <div className="font-semibold text-[14px]">
                                {bound?.nbStops}
                            </div>
                            <p className=" text-[14px] text-paragraph-color">
                                {bound?.duration2}
                            </p>
                        </div>
                    )}
                </div>
                <div className="flex flex-col items-center flex-1">
                    <h3 className="font-semibold">{bound?.arrival_time}</h3>
                    <h6 className="text-paragraph-color text-[14px] w-[150px] text-center ">
                        {bound?.arrival_airport}
                    </h6>
                </div>
            </div>
        </div>
    );
};